import { useQuery } from '@tanstack/react-query';
import { fetchRefuelingContract } from '../../api/refueling-contract.ts';
import type { RefuelingContract } from '../../models/refueling-contract.ts';

export default function useRefuelingContract(
  partnerId: string,
  id: string,
  enabled: boolean = true,
) {
  const response = useQuery<{ data: RefuelingContract }>({
    queryKey: ['partner', partnerId, 'refuelingContract', id],
    queryFn: () => fetchRefuelingContract(partnerId, id),
    enabled,
  });
  const { data, ...rest } = response;
  return { refuelingContract: data?.data, ...rest };
}
